<template>
  <div>
    <p>本アプリは実証実験用のアプリであり、下記の条件で実験参加者を募集しています。</p>
    <p>期間：2020年10月3日（土） 〜 11月1日（日）</p>
    <p>対象者：<br>
    - 自家用車またはレンタカーを利用する観光客の方<br>
      <br>
      <br>
      実験参加者には、アプリ内アンケートを回答していただいた方に、Amazonギフト券Eメールタイプ500円分の薄謝を進呈いたします。
    </p>
  </div>
</template>

<script>
export default {
  name: 'experiment-participant-sentence'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Molecules/ExperimentParticipationSentence.vue